import React from 'react';
import {
  css,
  FlattenSimpleInterpolation,
  SimpleInterpolation,
  ThemeProvider,
} from 'styled-components';
import * as Colors from './colors';
import * as Fonts from './fonts';

export const theme = {
  color: {
    primary: Colors.Navy,
    secondary: Colors.Grey,
    danger: Colors.Red,
    warning: '#545454', // Do we use coral here?
    white: Colors.White,
    purple: Colors.Purple,
  },
  font: {
    family: {
      primary: Fonts.BodyFont, // Deprecate
      body: Fonts.BodyFont,
      heading: Fonts.HeadlineFont,
    },
    size: {
      small: '14px',
      default: '16px',
      medium: '18px',
      large: '21px',
      xlarge: '28px',
      xxlarge: '37px',
      xxxlarge: '50px',
    },
    weight: {
      light: 200,
      default: 400,
      medium: 500,
      bold: 700,
      black: 900,
    },
  },
  media: {
    belowSm: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width <= 375px) {
      ${args}
    }
  `,
    aboveSm: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width > 375px) {
      ${args}
    }
  `,
    belowMd: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width <= 650px) {
      ${args}
    }
  `,
    aboveMd: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width > 650px) {
      ${args}
    }
  `,
    belowLg: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width <= 700px) {
      ${args}
    }
  `,
    aboveLg: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width > 700px) {
      ${args}
    }
  `,
    aboveXl: (args: SimpleInterpolation[]): FlattenSimpleInterpolation => css`
    @media (width > 1536px) {
      ${args}
    }
  `,
  },
  breakpoints: {
    sm: '374px',
    md: '650px',
    lg: '700px',
  },
} as const;

function NewBrandThemeProvider(props: { children: React.ReactNode }) {
  return <ThemeProvider theme={theme} {...props} />;
}

export default NewBrandThemeProvider;
